import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const usersOverviewTableHeadings = [
	{ data: 'ID', title: 'ID' },
	{ data: 'displayName', title: ls('Name') },
	{ data: 'firstName', title: ls('First Name') },
	{ data: 'lastName', title: ls('Last Name') },
	{ data: 'userLogin', title: ls('Username') },
	{ data: 'email', title: ls('Email Address') },
	{
		data: 'coursesEnrolled',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsCoursesEnrolled, reportingApiSetup.learnDashLabels.courses)
	},
	{ data: 'notStarted', title: ls('Not Started') },
	{ data: 'inProgress', title: ls('In Progress') },
	{ data: 'completed', title: ls('Completed') },
	{ data: 'details', title: reportingApiSetup.localizedStrings.tablesColumnsDetails, className: 'no-sort' }
];

const usersOverviewTableData = function () {
	var userDataList = dataObject.userList.userOverview,
		tableData = [];

	for (let user in userDataList) {
		let details = `<span class="reporting-table-see-details">${reportingApiSetup.localizedStrings.tablesButtonSeeDetails}</span>`;
		let displayName = `<span class="reporting-table-see-details">${userDataList[user].display_name}</span>`;

		let coursesEnrolled = userDataList[user].enrolled;
		let inProgress = userDataList[user].in_progress;
		let completed = userDataList[user].completed;
		let notStarted = coursesEnrolled - completed - inProgress;

		if (0 >= notStarted) {
			notStarted = 0;
		}

		tableData.push({
			ID: userDataList[user].ID,
			displayName: displayName,
			firstName: userDataList[user].first_name,
			lastName: userDataList[user].last_name,
			userLogin: userDataList[user].user_login,
			email: userDataList[user].user_email,
			coursesEnrolled: coursesEnrolled,
			notStarted: notStarted,
			inProgress: inProgress,
			completed: completed,
			details: details
		});
	}

	dataObject.addToDataTables('usersOverviewTableData', tableData);

	return tableData;
};

export {
	usersOverviewTableHeadings,
	usersOverviewTableData
};
